import ContentFormContainer from "./ContentFormContainer";

export default function ContentUnitForm() {
  return <ContentFormContainer />;
}
